import classnames from 'classnames/bind'
import { STORYBLOK_COMPONENTS } from '~/lib/storyblok-types'

import { ProductsPinsPushProps } from '~/components/Abstracts/ProductsPins'
import { ImageWithLabelProps } from '~/components/Slices/ImageWithLabel'
import { AccordionItemProps } from '~/components/UI/AccordionItems'
import { CustomTableProps } from '~/components/UI/CustomTable'
import PushTitleLink, {
  PushTitleLinkProps,
} from '~/components/UI/PushTitleLink'
import { QuoteProps } from '~/components/UI/Quote'
import TwoColumnsHeaderTitle from '~/components/UI/TwoColumnsHeaderTitle'
import TwoColumnsLayout from '~/components/UI/TwoColumnsLayout'
import { RowProps } from '~/components/UI/TwoColumnsLayout/RightColumnRow'
import Wysiwyg, { WysiwygProps } from '~/components/UI/Wysiwyg'

import { EditoSliceProps } from '~/data/slices-data'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type RightColumnContents = (
  | WysiwygProps
  | QuoteProps
  | Omit<CustomTableProps, 'className'>
  | ImageWithLabelProps
  | AccordionItemProps
  | ProductsPinsPushProps
) & {
  type: string
}

type LeftColumnContents = (WysiwygProps | PushTitleLinkProps) & { type: string }

export const TwoColumnsLayoutsTypes = {
  HALVES: 'halves',
  THIRDS: 'thirds',
} as const

type TwoColumnsLayoutsTypes =
  typeof TwoColumnsLayoutsTypes[keyof typeof TwoColumnsLayoutsTypes]

export type TwoColumnsLayoutLineProps = EditoSliceProps & {
  className?: string
  layout?: TwoColumnsLayoutsTypes
  leftColumn?: LeftColumnContents[]
  rightColumn?: RowProps[]
  isHero?: boolean
}

function TwoColumnsLayoutLine({
  className,
  layout,
  leftColumn,
  rightColumn,
  isHero,
}: TwoColumnsLayoutLineProps) {
  const leftColumnComponents = leftColumn?.map(({ type, ...props }, i) => {
    switch (type) {
      case STORYBLOK_COMPONENTS.WYSIWYG:
        return (
          <Wysiwyg
            key={`left_column_item_${i}`}
            className={cx(css.item)}
            {...props}
          />
        )
      case STORYBLOK_COMPONENTS.PUSH_TITLE_LINK:
        return (
          <PushTitleLink
            key={`left_column_item_${i}`}
            className={cx(css.item)}
            {...props}
          />
        )
      case STORYBLOK_COMPONENTS.HERO_TWO_COLS_LAYOUT_TITLE_SUBTITLE:
        return (
          <TwoColumnsHeaderTitle
            className={cx(css.item)}
            key={`left_column_item_${i}`}
            isHero={isHero}
            {...props}
          />
        )
    }
  })

  return (
    <TwoColumnsLayout
      className={cx(css.TwoColumnsLayoutLine, className)}
      layout={layout}
      leftColumnClassName={cx(css.leftColumn)}
      rightColumnClassName={cx(
        css.rightColumn,
        css?.[`layout-${rightColumn?.length}-items`],
      )}
      leftColumnComponents={leftColumnComponents}
      rightColumnComponents={rightColumn}
    />
  )
}

TwoColumnsLayoutLine.defaultProps = {}

export default TwoColumnsLayoutLine
